export const facebook = "http://www.facebook.com/tomislav.martincic.1"
export const github = "http://www.github.com/gnomearcy"
export const twitter = "http://www.twitter.com/gnomearcy"
export const codepen = "http://www.codepen.io/gnomearceh";
export const linkedin = "http://www.linkedin.com/in/tomislav-martincic"

const hoverColor = "hoverColor";

export {
  hoverColor as hoverColorKey
}

export default [
  {
    link: facebook,
    icon: "fa-facebook",
    [hoverColor]: "#3b5998"
  },
  {
    link: github,
    icon: "fa-github",
    [hoverColor]: "#040204"
  },
  {
    link: twitter,
    icon: "fa-twitter",
    [hoverColor]: "#00B6F1"
  },
  {
    link: codepen,
    icon: "fa-codepen",
    [hoverColor]: "#212121"
  },
  {
    link: linkedin,
    icon: "fa-linkedin",
    [hoverColor]: "#04669A"
  }
]



// WEBPACK FOOTER //
// ./src/data/social_media_links.js